import { createElement } from 'react';
import './index.scss';
import { bizCssPrefix } from '../../variables';
const box = bizCssPrefix + '-colorful-text';
const HhNumber = function HhNumber({ text = "abc", width = 100, units = 'px', style = {}, ...otherProps }) {
    const _style = style || {};
    _style.width = width + units;
    const _otherProps = otherProps || {};
    _otherProps.style = _style;
    return (createElement("div", { ..._otherProps }, text));
};
HhNumber.displayName = 'HhNumber';
HhNumber.defaultProps = {
    width: 100
};
export default HhNumber;
